import { motion } from "framer-motion";
import { waLink } from "@/config/site";

export const FloatingWhatsApp = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Gartenprojekt über WhatsApp besprechen"
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="group fixed bottom-5 right-5 z-[60] flex items-center gap-3 md:bottom-8 md:right-8"
  >
    <span className="pointer-events-none max-w-0 overflow-hidden whitespace-nowrap rounded-full bg-[#17251C]/92 text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-[#DCCDB4] opacity-0 backdrop-blur-md transition-all duration-500 group-hover:max-w-[260px] group-hover:px-5 group-hover:py-3 group-hover:opacity-100">
      Gartenprojekt besprechen
    </span>
    <span className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#DCCDB4]/40 bg-[#17251C] transition-colors duration-500 group-hover:bg-[#B4623C]">
      <svg viewBox="0 0 32 32" className="h-6 w-6 fill-[#F3EDE2]" aria-hidden="true">
        <path d="M16.04 3.2c-7.06 0-12.8 5.73-12.8 12.79 0 2.25.6 4.45 1.72 6.39L3.2 28.8l6.6-1.72a12.8 12.8 0 0 0 6.24 1.6h.01c7.05 0 12.79-5.74 12.79-12.8 0-3.42-1.33-6.63-3.75-9.04a12.68 12.68 0 0 0-9.05-3.64Zm0 23.02h-.01a10.6 10.6 0 0 1-5.41-1.48l-.39-.23-4.02 1.05 1.07-3.92-.25-.4a10.6 10.6 0 0 1-1.63-5.65c0-5.87 4.78-10.64 10.65-10.64 2.84 0 5.51 1.11 7.52 3.12a10.57 10.57 0 0 1 3.11 7.53c0 5.87-4.78 10.62-10.64 10.62Zm5.83-7.96c-.32-.16-1.98-.98-2.28-1.09-.31-.11-.53-.17-.75.17-.22.32-.86 1.08-1.05 1.3-.2.22-.39.24-.71.08-.32-.16-1.37-.5-2.6-1.6-.96-.86-1.6-1.92-1.79-2.24-.19-.32-.02-.5.14-.66.15-.15.32-.38.48-.58.16-.19.21-.32.32-.54.1-.21.05-.4-.03-.56-.08-.16-.71-1.83-.99-2.5-.26-.66-.53-.57-.73-.58h-.63c-.22 0-.57.08-.86.4-.3.32-1.13 1.1-1.13 2.69 0 1.58 1.15 3.11 1.31 3.33.16.21 2.23 3.55 5.44 4.85.76.33 1.35.52 1.82.67.77.24 1.47.21 2.02.13.62-.09 2.04-.83 2.32-1.64.29-.8.29-1.5.2-1.64-.08-.13-.29-.21-.61-.37Z" />
      </svg>
      <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-[#93A387]">
        <span className="absolute inset-0 animate-ping rounded-full bg-[#93A387] opacity-60" />
      </span>
    </span>
  </motion.a>
);
